import { Grid, Text } from '@farmersdog/corgi-x';

import CalendarSvg from './assets/calendar.svg';
import PhoneSvg from './assets/phone.svg';
import WeightManagementSvg from './assets/weightManagement.svg';
import styles from './Benefits.module.css';

interface BenefitsArgs {
  isMobile: boolean;
  dogName: string;
}

export const BENEFITS_LIST = [
  {
    label: 'Real people standing by to support 24/7',
    icon: <PhoneSvg />,
  },
  {
    label: 'Delivered on a schedule that works for you',
    icon: <CalendarSvg />,
  },
  {
    label: 'A personalized plan built for your dog',
    icon: <WeightManagementSvg />,
  },
];

export function Benefits({ isMobile, dogName }: BenefitsArgs) {
  return (
    <Grid justify="center">
      <Text
        variant={isMobile ? 'article-16' : 'article-20'}
        className={styles.title}
      >
        Your vet created this plan just for {dogName}. They know what’s best for
        your pup and we’re here to make that easy.
      </Text>
      <ul className={styles.benefits}>
        {BENEFITS_LIST.map(({ icon, label }) => (
          <li key={label} className={styles.benefit}>
            <div className={styles.icon}>{icon}</div>
            <Text variant={isMobile ? 'heading-12' : 'heading-16'} bold>
              {label}
            </Text>
          </li>
        ))}
      </ul>
    </Grid>
  );
}
